import React from "react";
import { X } from "lucide-react";
import { cn } from "@/lib/utils";

/** Navy bar shown while rows are selected: what is selected, the actions, and a clear button */
export function BulkBar({ count, detail, onClear, children, className }: { count: number; detail?: React.ReactNode; onClear: () => void; children: React.ReactNode; className?: string }) {
  if (count === 0) return null;
  return (
    <div role="region" aria-label="Bulk actions" className={cn("flex min-h-[38px] flex-wrap items-center gap-x-4 gap-y-1 rounded-lg bg-sidebar px-3.5 py-1 text-white", className)}>
      <span className="text-[13px] font-semibold">{count} selected</span>
      {detail && <span className="text-xs text-sidebar-foreground">{detail}</span>}
      <span className="h-[18px] w-px bg-white/20" aria-hidden="true" />
      <div className="flex flex-wrap items-center gap-x-4 text-[13px] font-medium [&_button]:text-white/90 [&_button:hover]:text-white">{children}</div>
      <button type="button" onClick={onClear} aria-label="Clear selection" className="ml-auto flex size-6 items-center justify-center rounded-md bg-sidebar-accent text-white hover:bg-white/20">
        <X className="size-3.5" />
      </button>
    </div>
  );
}

/** A text action inside the bulk bar */
export function BulkButton({ children, onClick, disabled }: { children: React.ReactNode; onClick: () => void; disabled?: boolean }) {
  return (
    <button type="button" onClick={onClick} disabled={disabled} className="inline-flex h-7 items-center gap-1.5 hover:underline disabled:opacity-50">
      {children}
    </button>
  );
}
